// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8995ff2","914":"3c8af26a"}[chunkId] + ".chunk.js";
};